export default {
  sections: {
    setup_fee: {
      title: 'Setup costs',
      description: 'Setup costs from {{amount}} – instead of 1,000+',
    },
  },
  labels: {
    month: 'Month (NET)',
    one_time_fee: 'One-time fee',
    more_options: 'More options',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Your own app in the App Store & Google Play',
    push_notifications: 'Push notifications for offers',
    loyalty: 'Customer retention through loyalty programs',
    offline_orders: 'Offline orders possible',
    individual_design: 'Individual App Design',
  },
  setup_fee_options: {
    150: 'Standard setup',
    75: 'Reduced',
    0: 'No creation costs',
  },
  feedback: {
    contract_signed_already: {
      title: 'Contract is already signed',
      description: 'Please contact tech support if you need to do the changes',
    },
  },
};
